import React, { Component } from 'react'
import { Router, Switch, Route } from 'react-router'
import { Provider } from 'react-redux'
import PrivateRoute from 'components/PrivateRoute'
import history from 'utils/history'

import AppLoading from 'components/AppLoading'
import Public from 'containers/Public'
import Admin from 'containers/Admin'
import Manage from 'containers/Manage'

import store from 'store'
import * as accountActions from 'actions/account'

class App extends Component {
  state = {
    initialized: false,
  }

  componentDidMount = async () => {
    try {
      const account = await accountActions.getStoredAccount()
      if (account && 'Super Admin' === account.role) {
        history.push('/admin/clients')
      } else if ('Admin' === account.role) {
        history.push('/manage/customers')
      }
    } catch (e) {
      // handle exception
    } finally {
      this.setState({ initialized: true })
    }
  }

  render = () => {
    return (
      <Provider store={store}>
        {this.state.initialized ? (
          <Router history={history}>
            <Switch>
              <PrivateRoute roles={['Super Admin']} path="/admin" component={Admin} />
              <PrivateRoute roles={['Admin']} path="/manage" component={Manage} />
              <Route path="/" component={Public} />
            </Switch>
          </Router>
        ) : (
          <AppLoading />
        )}
      </Provider>
    )
  }
}

export default App
